// extracted by mini-css-extract-plugin
module.exports = {"leadershipGrid":"LeadershipGrid_leadershipGrid__HdeXI","row":"LeadershipGrid_row__JEz0E","cell":"LeadershipGrid_cell__p6NND"};